import styled from "@emotion/styled";
import { CheckIcon } from "@heroicons/react/20/solid";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../redux/root";
import { earnReferralSocialBonus as earnReferralSocialBonusAction } from "../../redux/team";
import { analyticsEvent } from "@util/analytics";

import InviteField from "../revamped/form/InviteField";

const StyledLabel = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
`;

const LabelBadge = styled.div`
  display: flex;
  align-items: center;
  margin: -1px 0;
  padding: 0 4px;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  text-transform: none;
  line-height: 150%;
  background: linear-gradient(118.5deg, #44eda6 15.79%, #1eb7e8 124.44%);
  border-radius: 100px;
  color: #000;
`;

const StyledCheckIcon = styled(CheckIcon)`
  display: inline-block;
  width: 12px;
  height: 12px;
  margin: 0 2px;
`;

const ReferralInviteField = () => {
  const dispatch = useDispatch();
  const referralSocialBonuses = useSelector(
    (state: RootState) => state.team.referralSocialBonuses,
  );
  const earningSocialBonus = useSelector(
    (state: RootState) => state.team.earningSocialBonus,
  );

  const [showSuccessBadge, setShowSuccessBadge] = useState(false);
  const [success, setSuccess] = useState(false);
  const [inviting, setInviting] = useState(false);
  const [error, setError] = useState("");

  const invitedByEmail = referralSocialBonuses.value?.mediums.includes("email");

  const handleSubmit = useCallback(
    (emails: string[]) => {
      setInviting(true);

      dispatch(earnReferralSocialBonusAction({ emails, medium: "email" }));

      if (!invitedByEmail) {
        setShowSuccessBadge(true);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
    [invitedByEmail],
  );

  const handleReset = useCallback(() => {
    setError("");
    setSuccess(false);
  }, []);

  useEffect(() => {
    if (!inviting || earningSocialBonus.isLoading) return;

    if (earningSocialBonus.error) {
      setError(earningSocialBonus.error?.message);
    } else {
      analyticsEvent("Referral: Sent email invite");

      setSuccess(true);
    }

    setInviting(false);
  }, [inviting, earningSocialBonus]);

  const badge =
    success && showSuccessBadge ? (
      <LabelBadge>
        <StyledCheckIcon /> You’ve earned $10
      </LabelBadge>
    ) : invitedByEmail ? null : (
      <LabelBadge>Get $10 right away</LabelBadge>
    );

  return (
    <InviteField
      placeholder="emily@email.com, john@email.com"
      label={<StyledLabel>enter email address {badge}</StyledLabel>}
      required={true}
      loading={inviting || earningSocialBonus.isLoading}
      error={error}
      success={success}
      onSubmit={handleSubmit}
      onReset={handleReset}
    />
  );
};

export default ReferralInviteField;
